window.TV2 = window.TV2 || {};

window.TV2.taxlistToggle = (contentbox) => {
  const taxlist = document.getElementById(contentbox);
  const clickableRows = taxlist.querySelectorAll('.skattelisten__row--clickable');
  const showMoreButton = taxlist.querySelector('.skattelisten__show-all');
  const bodyElement = taxlist.querySelector('.skattelisten__body');

  clickableRows.forEach((row) =>
    row.addEventListener('click', () => {
      const expandableInfoElement = row.querySelector('.skattelisten__expandable-information');
      const caret = row.querySelector('.skattelisten__expand-icon');
      const firstColumn = row.querySelector('.skattelisten__item');
      const numberCell = row.querySelector('.skattelisten__number');
      const expandCell = row.querySelector('.skattelisten__expand');

      expandableInfoElement.style.marginLeft = `${firstColumn.clientWidth}px`;
      expandableInfoElement.style.marginRight = `${expandCell.clientWidth}px`;
      caret.classList.toggle('skattelisten__expand-icon--open');
      row.children[1].classList.toggle('skattelisten__expandable-information--show');

      if (numberCell.innerHTML === '---') {
        numberCell.innerHTML = numberCell.getAttribute('data-value');
      } else {
        numberCell.innerHTML = '---';
      }

      numberCell.style.width = `${numberCell.clientWidth}px`;
    }),
  );

  if (showMoreButton) {
    showMoreButton.addEventListener('click', () => {
      taxlist.classList.toggle('skattelisten--collapsed');
      showMoreButton.classList.toggle('skattelisten__show-all--open');
      bodyElement.classList.toggle('skattelisten__body--open');
    });
  }
};
